export interface PhysicalPhoneAnsibleInfo {
  id: string
  name: string
  terminalId: string
  status: string
}

export interface PhysicalPhone {
  id: string
  name: string
  deviceModel: string
  serialNumber: string
  imei?: string
  ansibleId?: string
  ansible?: PhysicalPhoneAnsibleInfo
  terminalId?: string
  macMiniUserId?: string
  macMiniUser?: import('./pns-mac-mini-user').PnsMacMiniUser
  status: PhoneStatus
  lastHealthCheck?: string
  assignmentChangedAt?: string
  lastRestartAt?: string
  createdAt: string
  updatedAt: string
  isAssigned: boolean
  isAvailable: boolean
  appleIdConfigId?: string
  appleIdConfig?: import('./pns-phone-number').AppleIdConfig
}

export enum PhoneStatus {
  RECEIVED = 'RECEIVED',
  AVAILABLE = 'AVAILABLE',
  ICLOUD_SETUP_IN_PROGRESS = 'ICLOUD_SETUP_IN_PROGRESS',
  WARMING = 'WARMING',
  ACTIVE = 'ACTIVE',
  MAINTENANCE = 'MAINTENANCE',
  RELOCATING = 'RELOCATING',
  OFFLINE = 'OFFLINE',
  DECOMMISSIONED = 'DECOMMISSIONED',
}

export interface PaginatedPhysicalPhoneResponse {
  data: PhysicalPhone[]
  pagination: {
    total: number
    count: number
    limit: number
    offset: number
    hasMore: boolean
    currentPage: number
    totalPages: number
  }
}

export interface PhysicalPhoneCountResponse {
  total: number
  byStatus: {
    [key in PhoneStatus]: number
  }
}
